<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<title>Ruth Bader Ginsburg: In Her Own Words</title>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<section epub:type="bodymatter" title="Part I: The Law">
<p class="h1" id="pa1"><span class="right_1" epub:type="pagebreak" id="page_7" title="7"><a href="#/text/Contents#rpa1">Part I</a></span></p>
<figure>
<p class="image"><a href="#/text/Contents#rpa1"><img alt="image" height="291" src="images/pa1.jpg" width="291"/></a></p>
</figure>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Part01.vue?41c3563b